import React, { useContext, useEffect } from "react";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import LinehaulFloatingDataTable from "./LinehaulFloatingDataTable";
import { LinehaulFloatingDataContext } from "../../Contexts/LinehaulFloatingDataContext";
import CreateLinehaulFloatingFab from "./CreateLinehaulFloatingFab";
import { AppStateContext } from "../../Contexts/AppStateContext";

const useStyles = makeStyles((theme) => ({
  add: {
    textAlign: "center",
  },
}));

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const LinehaulFloatingDisplayDay = (props) => {
  const { linehaulFloatingData } = useContext(LinehaulFloatingDataContext);
  const classes = useStyles();
  const { truckId, week, day } = props;
  const { tableOpen, setTableOpen, scrollToPosition } =
    useContext(AppStateContext);

  let data = {};
  if (truckId in linehaulFloatingData) {
    if (week in linehaulFloatingData[truckId]) {
      if (day in linehaulFloatingData[truckId][week]) {
        data = linehaulFloatingData[truckId][week][day];
      }
    }
  }

  // // return to uses last position before a refresh was done
  // useEffect(() => {
  //   scrollToPosition();
  // }, [linehaulFloatingData, scrollToPosition]);

  return (
    <Accordion
      expanded={tableOpen[day]}
      onChange={(event, isExpanded) =>
        setTableOpen({ ...tableOpen, [day]: isExpanded })
      }
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="flex-start"
        >
          <Grid item xs={6}>
            <Typography>{days[day]}</Typography>
          </Grid>
          <Grid item xs={6}>{`Records: ${Object.keys(data).length}`}</Grid>
        </Grid>
      </AccordionSummary>

      <AccordionDetails>
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="stretch"
          spacing={2}
        >
          <Grid item className={classes.add}>
            {/* <Fab onClick={() => setDialogOpen(true)} color="primary">
                <AddIcon />
              </Fab> */}
            <CreateLinehaulFloatingFab
              truckId={truckId}
              week={week}
              day={day}
            />
          </Grid>
          <Grid item>
            <LinehaulFloatingDataTable
              data={data}
              truckId={truckId}
              week={week}
              day={day}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default LinehaulFloatingDisplayDay;

/*

      <LinehaulAdjustment
        adjustmentType={"add"}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        truckId={truckId}
        week={week}
        day={day}
      />

*/
